<template>
  <div class="deposit-container">
    <div v-if="xieshow" class="protocolPopUp">
      <div class="title">
        协议区别
        <div @click="openXie" class="close"></div>
      </div>
      <div class="content">
        <img src="/static/image/xieyi.svg" alt="协议说明" />
      </div>
    </div>

    <div class="cardgroup">
      <div class="channels">
        <div 
          @click="changTab(0)" 
          :class="tab == 0 ? 'channel active' : 'channel'" 
          v-if="payWayList.usdt == 1"
        >
          <div class="title">数字货币</div>
          <div class="border"></div>
        </div>
        <div 
          @click="changTab(1)" 
          :class="tab == 1 ? 'channel active' : 'channel'" 
          v-if="showRmbTab"
        >
          <div class="title">人民币</div>
          <div class="border"></div>
        </div>
      </div>
    </div>

    <div class="deposit" v-if="tab == 0">
      <div class="deposit__content">
        <p class="deposit__title">支付方式</p>
        <div class="deposit__list-container">
          <ul class="deposit__list">
            <li 
              class="deposit__item" 
              :class="{active: selectedUsdtType === 'normal'}"
              @click="changUsdtType('normal')"
            >
              <img src="/static/image/usdt.png" alt="USDT" class="deposit__icon" />
              <p>人工转账</p>
            </li>
            <li 
              v-if="payWayList.epayusdt == 1"
              class="deposit__item" 
              :class="{active: selectedUsdtType === 'epayusdt'}"
              @click="changUsdtType('epayusdt')"
            >
              <img src="/static/style/usdt.svg" alt="EPAY USDT" class="deposit__icon" />
              <p>在线转账</p>
            </li>
          </ul>
        </div>

        <div class="protocol-box">
          <p class="sub-tips">
            钱包协议 
            <img 
              @click="openXie" 
              style="width: 18px; height: 18px; margin-left: 4px;" 
              src="/static/image/xieyi.svg" 
              alt="协议说明" 
            />
          </p>
          <div class="dcbox-protocol">
            <div 
              :class="meyXi == 'TRC20' ? 'protocol-item active' : 'protocol-item'" 
              @click="changMeyXi('TRC20')"
            >
              <span class="circle"></span>
              <span class="text">TRC20</span>
              <img src="/static/image/tuijian.svg" alt="推荐" style="width: 55px; height: 42px;" />
            </div>
            <div 
              :class="meyXi == 'ERC20' ? 'protocol-item active' : 'protocol-item'" 
              @click="changMeyXi('ERC20')"
            >
              <span class="circle"></span>
              <span class="text">ERC20</span>
            </div>
          </div>
        </div>

        <div class="deposit-input">
          <p class="deposit-input-title">金额</p>
          <div class="deposit__amount-input-wrapper">
            <input 
              id="amount1" 
              v-model="amount" 
              placeholder="请输入金额" 
              type="text" 
              class="deposit__amount-input" 
              @input="calculateUSDT"
            />
            <span class="deposit__amount-unit">CNY</span>
          </div>
        </div>

        <div class="deposit__rate-wrap">
          <p class="deposit__usdt-estimate">
            ≈{{ calculatedUSDT || '0.00' }} USDT 
          </p>
          <div class="deposit__rate-row">
            <p class="deposit__cny-tips">
              实时汇率：1 USDT = {{ usdtRate || '0.00' }} CNY 
            </p>
            <span class="refresh-tip" @click="getUSDTRealRate">🔄 刷新</span>
          </div>
        </div>

        <button class="deposit__button" @click="handleUsdtPay">确定</button>
      </div>

      <div class="dialog" v-if="ustShow">
        <div class="dialog-cover back" @click="closeUstShow"></div>
        <div class="dialog-content">
          <div class="side">
            <div class="side__header">
              <span>虚拟币存款</span>
              <a href="javascript:void 0;" @click="closeUstShow" class="side__close"></a>
            </div>
            <div class="side__content">
              <div class="scan">
                <div class="scan__amount">
                  <span>存款金额 </span>
                  <span class="scan__amount-number">{{ payInfo.info ? payInfo.info.amount : 0 }} CNY</span>
                </div>
                <div class="scan__amount">
                  <span>预计到账</span>
                  <span class="scan__amount-number">{{ payInfo.info ? payInfo.info.real_money : 0 }} USDT</span>
                </div>
                <p class="scan__title">使用钱包APP扫描二维码完成付款</p>
                <p class="scan__subtitle">可先截屏保存至相册，再使用钱包扫码转账</p>
                
                <div id="scanQr" class="scan__qr" :title="payInfo.cardlist ? payInfo.cardlist.mch_id : ''">
                  <img :src="(payInfo.cardlist && payInfo.cardlist.payimg) || payQrUrl" alt="支付二维码" style="display: block; max-width: 100%;" />
                </div>

                <div class="scan__protocol">{{ payInfo.info ? payInfo.info.bank : '' }}协议</div>

                <div class="scan__link">
                  <span>{{ payInfo.cardlist ? payInfo.cardlist.mch_id : '' }}</span>
                  <a 
                    @click="doCopy(payInfo.cardlist ? payInfo.cardlist.mch_id : '')" 
                    href="javascript:void 0;" 
                    class="scan__copy"
                  >
                    复制
                  </a>
                </div>

                <p class="scan__tips">*请选择正确的钱包协议类型进行存款,否则资产将无法找回</p>
                <button class="scan__button" @click="closeUstShow1">已完成支付</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="deposit" v-if="tab == 1">
      <div class="low-special">
        <p class="deposit-title">方式</p>
        <div class="pay-way-group">
          <div 
            @click="changPayway(1)" 
            :class="pay_way == 1 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'"
            v-if="payWayList.card == 1"
          >
            <div class="deposit-item">
              <div class="deposit-info">
                <div class="icon-wrapper">
                  <span class="icon icon-unionpay"></span>
                </div>
                <div class="pay-text">
                  <div class="main-text">银联支付</div>
                  <div class="sub-text">安全极速到账，存款无忧</div>
                </div>
              </div>
            </div>
          </div>

          <div 
            @click="changPayway(2)" 
            :class="pay_way == 2 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'"
            v-if="payWayList.alipay == 1"
          >
            <div class="deposit-item">
              <div class="deposit-info">
                <div class="icon-wrapper">
                  <span class="icon icon-alipay"></span>
                </div>
                <div class="pay-text">
                  <div class="main-text">支付宝支付</div>
                  <div class="sub-text">扫码便捷，实时到账</div>
                </div>
              </div>
            </div>
          </div>

          <div 
            @click="changPayway(3)" 
            :class="pay_way == 3 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'"
            v-if="payWayList.wechat == 1"
          >
            <div class="deposit-item">
              <div class="deposit-info">
                <div class="icon-wrapper">
                  <span class="icon icon-wechat"></span>
                </div>
                <div class="pay-text">
                  <div class="main-text">微信支付</div>
                  <div class="sub-text">微信扫码，安全高效</div>
                </div>
              </div>
            </div>
          </div>

          <div 
            @click="changPayway(4)" 
            :class="pay_way == 4 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'"
            v-if="payWayList.epayalipay == 1"
          >
            <div class="deposit-item">
              <div class="deposit-info">
                <div class="icon-wrapper">
                  <span class="icon icon-alipay"></span>
                </div>
                <div class="pay-text">
                  <div class="main-text">支付宝在线支付</div>
                  <div class="sub-text">在线渠道，实时到账</div>
                </div>
              </div>
            </div>
          </div>

          <div 
            @click="changPayway(5)" 
            :class="pay_way == 5 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'"
            v-if="payWayList.epaywxpay == 1"
          >
            <div class="deposit-item">
              <div class="deposit-info">
                <div class="icon-wrapper">
                  <span class="icon icon-wechat"></span>
                </div>
                <div class="pay-text">
                  <div class="main-text">微信在线支付</div>
                  <div class="sub-text">在线渠道，安全高效</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bank-info" v-if="pay_way == 1 && cardLis.length">
          <div class="bank-card-item" v-for="(item, index) in cardLis" :key="index">
            <p class="bank-label">收款银行：<span class="bank-value">{{ item.bank_data ? item.bank_data.bank_name : '' }}</span></p>
            <p class="bank-label">账号：<span class="bank-value">{{ item.bank_no ? item.bank_no : '' }}</span>
              <img 
                @click="doCopy(item.bank_no ? item.bank_no : '')" 
                style="width: 20px; float: right; margin-top: 2px;" 
                src="/static/image/clongicon.png" 
                alt="复制" 
                class="copy-icon"
              />
            </p>
            <p class="bank-label">户名：<span class="bank-value">{{ item.bank_owner ? item.bank_owner : '' }}</span>
              <img 
                @click="doCopy(item.bank_owner ? item.bank_owner : '')" 
                style="width: 20px; float: right; margin-top: 2px;" 
                src="/static/image/clongicon.png" 
                alt="复制" 
                class="copy-icon"
              />
            </p>
            <p class="bank-label">银行地址：<span class="bank-value">{{ item.bank_address ? item.bank_address : '' }}</span></p>
          </div>

          <p class="deposit-title">汇款姓名</p>
          <div class="amount-wrap">
            <input 
              placeholder="请输入汇款姓名" 
              v-model="bankBox.bank_owner" 
              type="text" 
              maxlength="17" 
              class="amount-input" 
            />
          </div>

          <p class="deposit-title">银行类型</p>
          <div class="amount-wrap">
            <el-select 
              v-model="bankBox.bank" 
              placeholder="请选择银行类型" 
              class="amount-input"
              style="background: #f8f9fa;"
            >
              <el-option 
                v-for="(item, index) in banklist" 
                :key="index" 
                :label="item.bank_name" 
                :value="item.bank_name"
              ></el-option>
            </el-select>
          </div>

          <p class="deposit-title">汇款卡号</p>
          <div class="amount-wrap">
            <input 
              placeholder="请输入汇款卡号" 
              v-model="bankBox.bank_no" 
              type="text" 
              maxlength="20" 
              class="amount-input" 
            />
          </div>

          <p class="deposit-title">开户行</p>
          <div class="amount-wrap">
            <input 
              placeholder="请输入开户行" 
              v-model="bankBox.bank_address" 
              type="text" 
              maxlength="20" 
              class="amount-input" 
            />
          </div>
        </div>

        <p class="deposit-title">金额</p>
        <div class="amount-wrap">
          <input 
            placeholder="请输入转账金额" 
            v-model="amount" 
            type="text" 
            maxlength="17" 
            class="amount-input" 
          />
          <div class="amount-unit">CNY</div>
        </div>

        <div class="wxsm-tips">
          <i class="tips-icon"></i>
          <div class="tips-text">
            温馨提示：选择此方式存款需于规定时间内完成，超时则无法到账，如有疑问请联系客服 
            <span @click="$parent.openKefu()" class="kefu-link">联系客服</span>
          </div>
        </div>

        <div class="low-special-btn" @click="handleRmbPay">确定</div>
      </div>

      <div class="dialog" v-if="wpShow">
        <div class="dialog-cover back" @click="closeUstShow"></div>
        <div class="dialog-content">
          <div class="side">
            <div class="side__header">
              <span>{{ payInfo.info ? payInfo.info.paytype : '' }}</span>
              <a href="javascript:void 0;" @click="closeUstShow" class="side__close"></a>
            </div>
            <div class="side__content">
              <div class="gold">
                <img :src="payInfo.cardlist ? payInfo.cardlist.payimg : ''" alt="支付二维码" class="gold__img" />
                <div class="gold__amount">
                  <span>存款金额 </span>
                  <span class="gold__amount-number">{{ payInfo.info ? payInfo.info.amount : 0 }} CNY</span>
                </div>
                <p class="scan__title">
                  请使用 <span class="c-yellow">{{ payInfo.info && payInfo.info.paytype == '支付宝二维码' ? '支付宝' : '微信' }}</span> 扫描二维码，完成付款
                </p>
                <p class="scan__subtitle">
                  可先截屏保存至相册，再使用{{ payInfo.info && payInfo.info.paytype == '支付宝二维码' ? '支付宝' : '微信' }}转账
                </p>
                <button class="scan__button" @click="closeUstShow1">已完成支付</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'deposit',
  data() {
    return {
      tab: 1,
      meyXi: 'TRC20',
      amount: null,
      pay_way: null,
      payInfo: {},
      ustShow: false,
      wpShow: false,
      xieshow: false,
      baseURL: '',
      cardLis: [],
      banklist: [],
      bankBox: {},
      payWayList: {},
      usdtRate: null,
      calculatedUSDT: '0.00',
      showRmbTab: false,
      selectedUsdtType: 'normal',
      payQrUrl: ''
    };
  },
  created() {
    this.baseURL = sessionStorage.getItem('baseURL') || '';
    this.initData();
  },
  methods: {
    initData() {
      this.$parent.showLoading();
      Promise.all([
        this.getPayWay(),
        this.getBanklist(),
        this.getcard(),
        this.getUSDTRealRate()
      ]).finally(() => {
        this.$parent.hideLoading();
      });
    },
    getPayWay() {
      return this.$apiFun.get('/api/get_pay_way', {}).then(res => {
        if (res.code === 200) {
          this.payWayList = res.data || {};
          this.showRmbTab = this.payWayList.card === 1 || this.payWayList.alipay === 1 || this.payWayList.wechat === 1 || this.payWayList.epayalipay === 1 || this.payWayList.epaywxpay === 1;
          
          const rmbPayWays = [
            { key: 'card', payWayVal: 1 },
            { key: 'alipay', payWayVal: 2 },
            { key: 'wechat', payWayVal: 3 },
            { key: 'epayalipay', payWayVal: 4 },
            { key: 'epaywxpay', payWayVal: 5 }
          ];
          
          const availablePayWays = rmbPayWays.filter(item => this.payWayList[item.key] === 1);
          let defaultPayWay = availablePayWays.length > 0 ? availablePayWays[0].payWayVal : null;

          if (this.payWayList.usdt === 1 && !defaultPayWay) {
            this.tab = 0;
            this.pay_way = 0;
          } else {
            this.tab = 1;
            this.pay_way = defaultPayWay || null;
          }
        }
      }).catch(err => {
        console.error('获取支付方式失败', err);
        this.showRmbTab = false;
      });
    },
    getBanklist() {
      return this.$apiFun.post('/api/banklist', {}).then(res => {
        if (res.code === 200) {
          this.banklist = res.data || [];
        } else {
          this.$parent.showTost(0, res.message);
        }
      }).catch(err => {
        console.error('获取银行列表失败', err);
        this.banklist = [];
      });
    },
    getcard() {
      return this.$apiFun.post('/api/getpaybank', {}).then(res => {
        if (res.code === 200) {
          this.cardLis = Array.isArray(res.data) && res.data.length ? res.data : [res.data].filter(Boolean);
        } else {
          this.$parent.showTost(0, res.message);
          this.cardLis = [];
        }
      }).catch(err => {
        console.error('获取银行卡信息失败', err);
        this.cardLis = [];
      });
    },
    getUSDTRealRate() {
      return axios.get('https://api.coingecko.com/api/v3/simple/price', {
        params: {
          ids: 'tether',
          vs_currencies: 'cny',
          include_last_updated_at: false
        },
        timeout: 5000
      }).then(response => {
        if (response.data && response.data.tether && response.data.tether.cny) {
          this.usdtRate = Number(response.data.tether.cny).toFixed(2);
          this.calculateUSDT();
        }
      }).catch(error => {
        console.error('获取USDT实时汇率失败，使用默认汇率', error);
        this.usdtRate = '7.10';
        this.calculateUSDT();
      });
    },
    calculateUSDT() {
      if (!this.amount || !this.usdtRate) {
        this.calculatedUSDT = '0.00';
        return;
      }
      const usdtAmount = (Number(this.amount) / Number(this.usdtRate)).toFixed(2);
      this.calculatedUSDT = usdtAmount;
    },
    openXie() {
      this.xieshow = !this.xieshow;
    },
    closeUstShow() {
      this.ustShow = false;
      this.wpShow = false;
      this.payInfo = {};
      this.payQrUrl = '';
    },
    closeUstShow1() {
      this.closeUstShow();
      this.$parent.goNav('/assets');
    },
    changTab(val) {
      if (this.tab === val) return;
      this.tab = val;
      this.pay_way = val === 0 ? 0 : 1;
      this.amount = null;
      this.calculatedUSDT = '0.00';
      if (val === 0) {
        this.selectedUsdtType = 'normal';
      }
    },
    changMeyXi(val) {
      this.meyXi = val;
    },
    changUsdtType(type) {
      this.selectedUsdtType = type;
    },
    changPayway(val) {
      if (this.pay_way === val) return;
      this.pay_way = val;
      this.bankBox = {};
      this.amount = null;
    },
    chongBi() {
      const payWayArr = ['usdt', 'bank', 'alipay', 'wechat'];
      const payType = payWayArr[this.pay_way];
      const info = {
        paytype: payType,
        amount: Number(this.amount)
      };

      if (!payType) {
        return this.$parent.showTost(0, '请选择有效的支付方式');
      }

      const payWayKey = {
        1: 'card',
        2: 'alipay',
        3: 'wechat'
      }[this.pay_way];
      
      if (!payWayKey || this.payWayList[payWayKey] !== 1) {
        return this.$parent.showTost(0, '当前选择的支付方式不可用，请重新选择');
      }

      if (payType === 'bank') {
        const { bank_owner, bank, bank_no, bank_address } = this.bankBox;
        if (!bank_owner) return this.$parent.showTost(0, '请输入存款人姓名');
        if (!bank) return this.$parent.showTost(0, '请选择银行类型');
        if (!bank_no) return this.$parent.showTost(0, '请输入银行卡号');
        if (!bank_address) return this.$parent.showTost(0, '请输入开户行地址');
        Object.assign(info, { bank, bank_address, bank_no, bank_owner });
      }

      if (info.amount <= 0 || isNaN(info.amount)) {
        return this.$parent.showTost(0, '请输入正确的金额（大于0的数字）');
      }

      this.$parent.showLoading();
      this.$apiFun.post('/api/recharge', info).then(res => {
        if (res.code !== 200) {
          return this.$parent.showTost(0, res.message);
        }

        if (payType === 'bank') {
          this.bankBox = {};
          this.amount = null;
          this.$parent.showTost(1, '操作成功，等待工作人员审核！');
          setTimeout(() => this.$parent.goNav('/assets'), 1500);
          return;
        }

        this.getpayinfo(res.message, 1);
      }).finally(() => {
        this.$parent.hideLoading();
      });
    },
    usdtchongBi() {
      let that = this;
      let info = {
        amount: that.amount,
        paytype: 'usdt',
        catepay: that.meyXi,
      };
    
      if (!that.amount || isNaN(Number(that.amount))) {
        that.$parent.showTost(0, '请输入有效数字金额');
        return;
      }
      if (Number(that.amount) <= 0) {
        that.$parent.showTost(0, '请输入正确金额');
        return;
      }
    
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            that.getpayinfo(res.message, 0);
          }
        })
        .catch(res => {
          that.$parent.hideLoading();
        })
        .finally(() => {
          that.$parent.hideLoading();
        });
    },
    // 修复后的易支付跳转方法（全部新窗口打开）
    epayChongBi(paytype) {
      let that = this;
      let info = {
        amount: that.amount,
        paytype: paytype,
        catepay: that.meyXi || ''
      };
    
      if (!that.amount || isNaN(Number(that.amount))) {
        that.$parent.showTost(0, '请输入有效数字金额');
        return;
      }
      if (Number(that.amount) <= 0) {
        that.$parent.showTost(0, '请输入正确金额');
        return;
      }
    
      that.$parent.showLoading();
      that.$apiFun.post('/api/epay_recharge', info).then(res => {
        that.$parent.hideLoading();
        if (res.code != 200) {
          that.$parent.showTost(0, res.msg || '创建支付订单失败');
          return;
        }
        that.amount = null;
        
        const payUrl = res.data.pay_url;
        if (payUrl) {
          // 调用专用的跳转处理方法（强制新窗口）
          that.handlePayUrlJump(payUrl, paytype);
        } else {
          that.$parent.showTost(0, '暂未获取到支付链接，将为您展示手动支付方式');
          that.getpayinfo(res.message, paytype === 'epayusdt' ? 0 : 1);
        }
      }).catch(err => {
        console.error('易支付创建订单失败：', err);
        that.$parent.hideLoading();
        that.$parent.showTost(0, '创建订单失败');
      });
    },
    handlePayUrlJump(payUrl, paytype) {
      const that = this;
      try {
        const newWindow = window.open(payUrl, '_blank');
        
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          const link = document.createElement('a');
          link.href = payUrl;
          link.target = '_blank'; 
          link.rel = 'noopener noreferrer';
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          that.$parent.showTost(0, '支付链接已在新窗口打开，如未弹出请检查浏览器弹窗设置');
        }
      } catch (e) {
        console.error('新窗口打开失败：', e);
        that.$parent.showTost(0, '无法自动打开新窗口，请手动复制以下链接在新窗口打开：' + payUrl);
      }
    },
    handleUsdtPay() {
      if (this.selectedUsdtType === 'epayusdt') {
        this.epayChongBi('epayusdt');
      } else {
        this.usdtchongBi();
      }
    },
    handleRmbPay() {
      if (this.pay_way === 4) {
        this.epayChongBi('alipay');
      } else if (this.pay_way === 5) {
        this.epayChongBi('wxpay');
      } else {
        this.chongBi();
      }
    },
    getpayinfo(depositNo, type) {
      this.$apiFun.post('/api/payinfo', { deposit_no: depositNo }).then(res => {
        if (res.code !== 200) {
          return this.$parent.showTost(0, res.message);
        }
        this.payInfo = res.data || {};
        type === 0 ? (this.ustShow = true) : (this.wpShow = true);
      }).catch(err => {
        console.error('获取支付信息失败', err);
        this.$parent.showTost(0, '获取支付信息失败');
      });
    },
    doCopy(text) {
      if (!text) return this.$parent.showTost(0, '暂无复制内容');
      
      const input = document.createElement('input');
      input.value = text;
      input.style.cssText = 'opacity:0; position:fixed; bottom:0; right:0; z-index:-1;';
      document.body.appendChild(input);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$parent.showTost(1, '复制成功！');
      } else {
        navigator.clipboard.writeText(text).then(() => {
          this.$parent.showTost(1, '复制成功！');
        }).catch(() => {
          this.$parent.showTost(0, '复制失败，请手动复制');
        });
      }
      document.body.removeChild(input);
    }
  }
};
</script>

<style lang="scss" scoped>
.deposit-container {
  background: #fff;
  min-height: 100vh;
  padding: 15px;
  box-sizing: border-box;
  color: #333;
}

.cardgroup {
  margin-bottom: 25px;
}
.channels {
  display: flex;
  gap: 20px;
  max-width: 400px;
  margin: 0 auto;
}
.channel {
  flex: 1;
  text-align: center;
  cursor: pointer;
  padding: 12px 0;
  border-bottom: 2px solid #eee;
  transition: all 0.3s ease;
}
.channel.active {
  border-bottom-color: #cca352;
}
.channel .title {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  margin-bottom: 3px;
}

.deposit {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.04);
  margin-bottom: 20px;
}
.deposit__title {
  font-size: 16px;
  color: #333;
  margin: 0 0 15px;
  font-weight: 500;
}

.deposit__list-container {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}
.deposit__list {
  display: flex;
  width: 100%;
  gap: 10px;
  list-style: none;
}

.deposit__item {
  width: 50%;	
  text-align: center;
  background: #fff;
  border-radius: 6px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}
.deposit__item.active {
    background: #ccc;
  border: 1px solid #cca352;
  color: #333;
  box-shadow: 0 2px 8px rgba(204, 163, 82, 0.1);
}
.deposit__icon {
  width: 30px;
  height: 30px;
  margin: 0 auto 8px;
  display: block;
}

.deposit__rate-wrap {
  margin-bottom: 25px;
}
.deposit__usdt-estimate {
  font-size: 14px;
  color: #666;
  margin: 0 0 8px;
}
.deposit__rate-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.deposit__cny-tips {
  font-size: 14px;
  color: #666;
  margin: 0;
}
.refresh-tip {
  color: #cca352;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background 0.2s;
  white-space: nowrap;
}
.refresh-tip:hover {
  background: #fff8e6;
}

.protocol-box {
  margin-bottom: 25px;
}
.sub-tips {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.dcbox-protocol {
  display: flex;
  gap: 20px;
  background: #f8f9fa;
  padding: 14px 20px;
  border-radius: 8px;
}
.protocol-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 6px 0;
}
.protocol-item.active {
  color: #cca352;
}
.circle {
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
}
.protocol-item.active .circle {
  border-color: #cca352;
}
.protocol-item.active .circle:after {
  content: '';
  width: 8px;
  height: 8px;
  background: #cca352;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.deposit-input-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 12px;
  font-weight: 500;
}
.deposit__amount-input-wrapper {
  position: relative;
  background: #f8f9fa;
  border-radius: 8px;
  height: 50px;
  margin-bottom: 15px;
}
.deposit__amount-input {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  padding: 0 18px;
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
}
.deposit__amount-input::placeholder {
  color: #999;
  font-size: 14px;
}
.deposit__amount-unit {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 18px;
  background: #eee;
  border-radius: 0 8px 8px 0;
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
}

.deposit__button,
.low-special-btn {
  width: 100%;
  height: 50px;
  background: #cca352;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  transition: background 0.3s ease;
}
.deposit__button:hover,
.low-special-btn:hover {
  background: #b89248;
}

.pay-way-group {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}
.deposit-bq {
  flex: 1;
  min-width: 200px;
  max-width: calc(33.33% - 10px);
  padding: 18px;
  border-radius: 8px;
  cursor: pointer;
  background: #f8f9fa;
  border: 1px solid transparent;
  transition: all 0.3s ease;
}
.deposit-bq.yesBorder {
  border-color: #cca352;
  background: #ccc;
  box-shadow: 0 2px 8px rgba(204, 163, 82, 0.1);
}
.deposit-bq.noBorder:hover {
  background: #f0f0f0;
}
.deposit-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
.icon-wrapper {
  width: 45px;
  height: 45px;
  border-radius: 8px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.icon {
  width: 45px;
  height: 45px;
  display: inline-block;
}
.icon-unionpay {
  background: url(/static/style/unionpay.cdca8e6e.png) no-repeat center;
  background-size: 45px 45px;
}
.icon-alipay {
  background: url(/static/style/alipay.svg) no-repeat center;
  background-size: 45px 45px;
}
.icon-wechat {
  background: url(/static/style/wechat.svg) no-repeat center;
  background-size: 45px 45px;
}
.pay-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.main-text {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}
.sub-text {
  font-size: 12px;
  color: #666;
}

.bank-info {
  margin-bottom: 25px;
}
.bank-card-item {
  background: #f8f9fa;
  padding: 18px;
  border-radius: 8px;
  margin-bottom: 20px;
}
.bank-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.5;
  display: flex;
  align-items: center;
}
.bank-label:last-child {
  margin-bottom: 0;
}
.bank-value {
  color: #666;
  margin-left: 8px;
  flex: 1;
  word-break: break-all;
}
.copy-icon {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.copy-icon:hover {
  opacity: 1;
}

.amount-wrap {
  position: relative;
  background: #f8f9fa;
  border-radius: 8px;
  height: 50px;
  margin-bottom: 20px;
}
.amount-input {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  padding: 0 18px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
}
.amount-input::placeholder {
  color: #999;
  font-size: 14px;
}
.amount-unit {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 18px;
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
}

.wxsm-tips {
  font-size: 13px;
  color: #666;
  background: #fff8e6;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.tips-icon {
  width: 18px;
  height: 18px;
  background: url(/static/image/tips-icon.png) no-repeat center;
  background-size: 18px 18px;
  margin-top: 1px;
  flex-shrink: 0;
}
.tips-text {
  line-height: 1.5;
}
.kefu-link {
  color: #cca352;
  cursor: pointer;
  text-decoration: underline;
}

.dialog-cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  backdrop-filter: blur(2px);
}
.dialog-content {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  z-index: 1000;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 -3px 15px rgba(0, 0, 0, 0.08);
}
.side__header {
  position: relative;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 18px;
  color: #333;
  border-bottom: 1px solid #eee;
  font-weight: 500;
}
.side__close {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  background: url(data:image/png;base64,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) no-repeat center;
  background-size: 22px 22px;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.side__close:hover {
  opacity: 1;
}
.side__content {
  padding: 20px;
}

.scan, .gold {
  text-align: center;
}
.scan__amount, .gold__amount {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
}
.scan__amount-number, .gold__amount-number {
  color: #333;
  font-weight: 500;
  font-size: 15px;
}
.scan__title, .gold__title {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 500;
}
.scan__subtitle, .gold__subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 25px;
  line-height: 1.5;
}
.scan__qr {
  width: 200px;
  height: 200px;
  margin: 0 auto 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
}
.scan__qr img, .gold__img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
}
.scan__protocol {
  display: inline-block;
  padding: 8px 16px;
  background: #f8f9fa;
  color: #333;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 25px;
}
.scan__link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 25px;
  font-size: 12px;
  color: #333;
  overflow: hidden;
}

.scan__text {
  flex: 1;
  padding: 14px 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  word-break: break-all;
}

.scan__link {
  position: relative;
  padding: 14px 18px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 25px;
  font-size: 12px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.scan__copy {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 50px;
  background: #cca352;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 14px;
  border-radius: 0 8px 8px 0;
}
.scan__tips {
  font-size: 12px;
  color: #999;
  margin-bottom: 25px;
  line-height: 1.5;
  text-align: left;
}

.protocolPopUp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 1001;
  display: flex;
  flex-direction: column;
}
.protocolPopUp .title {
  height: 55px;
  line-height: 55px;
  font-size: 18px;
  color: #333;
  border-bottom: 1px solid #eee;
  position: relative;
  padding: 0 20px;
  font-weight: 500;
}
.protocolPopUp .close {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA6lJREFUaAXNWbtyFDEQvLXhUyD341dMQGQHRPA5OCKAiID7FduXw6eA65hWbcvSrB6jB3Vc1dVIo5nuaUmr3b3b7Uqfh4eHYzge9dmhDQN3RWc0GHUEQ/c97OFweLM7Ho+v8KVXon+w7QcjJ0fhDDOdn5ERLJ3M1IPSfymAQaEFgHxfpg4JcOhEHbiEKGgj4fHx8bc09/K9ub6+jmLOEBR+JPg7+ldXV+9hNSN87qOp6UdCVCqmHQ4G5CwTd26dclEJ/0J0LU7HIm5Zlm/Ojw4TdSD66/jL5gicGy3JYKJqplRwtChkIoDYvWh7F/TTTc0URm1WGsFARtDaDuPjtq65xJSeupVlw6SRY16/Dm7KudLV2SDLgr30/Pz8E6iypV/L8v/RDK19AceuuEGeW7fgInNYvUQhsAA5ldHG6CVKAbtKqYAdWitRCZhYkQI6aXNEFmBiFAkYpIlWf3UnIW5z6RA0tDw4Q5+0b0CsfJtuUUFuKrSi0q5LEuSAdXkWoojACtxC5Ah6gU1ECBICd4eQubzTST19Tp0cO/cuv/XeZiElJk9H5Jj2dQ2c1SPu/Pz87Zm/ecq+XteihpEdD8ERdHFx8WvaImtwXht+m47spBw4VHgCdHpISuAbglaSGniSwEpiAc8S1Eis4EWCHEkLeJUgRSI+97SAMW5FtHOfaBflgtTucmEWcASa7mgC5l4BggL21uenqgI95yGJ5Vm3qECDY1qEwD3qijWdXVkFKXBOi1qT4imcJCiBc4qsJBsCC3gLSUTQAm4l8QQ94BYSRzACXiNZZoCXSMKbvulsIVjOhruLN3337GI9W3LA9OPq5oOEv+nL0/NnmaqPCMLg5eXlB15UTDy1xVI+PT19EXuLWqS+e5mUT9FLpipyj0P01ELWPYjfdfxtiHViicOrIBkkwScRUio8rMmfE1BlTULsv/q01hAJYFGtIMwbsb2cSQEspBeU+RY7ylEUwAJGSYgT2lmYJgEknkE6A4P1wDYJYGJPET055CvZLgEEtBSF2PVnps05LkPDR/SQAKMQhoV2uHCCTRFAsMqKIGxa4eScJsBQPDmnihgWUCncv8Kx+sBOEdItoFZ4+CDYEhsINDWbBYwUM5KbU2MWMJN8JlZVwEwyPYszsLMCZoDrgnP9Ea6NgBGwXIFWfw+3F9CTbC2sNa6lFidAnlW+StJtgmjKWZ3ANblKQvDjgxzVd7mX+pMWrtXlhOCl3sfi7yH+ReSd/2FD1/kXqyYUaF3HgagAAAAASUVORK5CYII=) no-repeat center;
  background-size: 22px 22px;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.protocolPopUp .close:hover {
  opacity: 1;
}
.protocolPopUp .content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}
.protocolPopUp .content img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 0 auto;
  display: block;
}

.c-yellow {
  color: #cca352;
}

@media (max-width: 768px) {
  .pay-way-group {
    flex-direction: column;
    gap: 12px;
  }
  .deposit-bq {
    max-width: 100%;
    min-width: 100%;
  }
  .scan__qr {
    width: 160px;
    height: 160px;
  }
  .channels {
    max-width: 100%;
  }
  .deposit__item {
    padding: 12px 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/main/deposit.vue